import type { InjectionKey, Ref } from 'vue'

/**
 * ValidationProvider が ValidationObserver に登録する検査ハンドル
 */
export interface ValidationFieldHandle {
  /**
   * 検査対象のフィールド名（インスペクタ表示用）
   */
  readonly field: string,

  /**
   * 検査を実行し、通過したかどうかを返す
   */
  validate: () => Promise<boolean>,
}

/**
 * ValidationObserver が配下の ValidationProvider へ provide する区画コンテキスト
 * @description Provider は直近の Observer のコンテキストを inject し、namespace が一致する場合に自身を登録する。
 */
export interface ValidationObserverContext {
  namespace: Readonly<Ref<string>>,
  inProgress: Readonly<Ref<boolean>>,
  register: (handle: ValidationFieldHandle) => void,
  unregister: (handle: ValidationFieldHandle) => void,
}

export const VALIDATION_OBSERVER_KEY: InjectionKey<ValidationObserverContext> = Symbol('ValidationObserver')
